import React from "react";
import { Modal, Button } from "react-bootstrap";

const DetailModal = ({ show, onHide, title, details }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title || "Details"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          {details && Object.keys(details).length > 0 ? (
            <div className="row">
              {Object.entries(details).map(([label, value]) => (
                <div className="col-md-3 mb-3" key={label}>
                  <div className="p-3 border rounded shadow-sm bg-light">
                    <strong className="text-muted">{label}</strong>
                    <div>{value}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-muted text-center">No details available.</div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DetailModal;
